/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum AlertsActiveEnum {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
}
